import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import Introduction from './components/Introduction';
import Impact from './components/Impact';
import HowToHelp from './components/HowToHelp';
import Stories from './components/Stories';
import Contact from './components/Contact';
import Footer from './components/Footer';
import EventsPage from './components/EventsPage';

// Home Page Component
const HomePage = () => {
  return (
    <>
      <Header />
      <Hero />
      <Introduction />
      <Impact />
      <HowToHelp />
      <Stories />
      <Contact />
      <Footer />
    </>
  );
};

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/events" element={<EventsPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;